import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useNavigate, Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", { email, password });
      localStorage.setItem("ndpl_admin_token", r.data.token);
      toast.success("Welcome, Admin");
      nav("/admin");
    } catch (e) { toast.error(e.response?.data?.detail || "Invalid credentials"); }
    setLoading(false);
  };
  return (
    <div className="min-h-screen bg-[#050505] text-white grid place-items-center px-6">
      <form onSubmit={submit} className="w-full max-w-md p-8 bg-[#0B132B] border border-white/10 rounded-lg">
        <div className="flex items-center gap-3 justify-center">
          <ShieldCheck className="text-[#39FF14]" />
          <div className="font-display text-3xl">NDPL <span className="text-[#39FF14]">ADMIN</span></div>
        </div>
        <div className="mt-6 space-y-4">
          <label className="block"><span className="text-xs uppercase tracking-widest text-white/60">Email</span>
            <input data-testid="admin-email" value={email} onChange={(e)=>setEmail(e.target.value)} className="mt-2 w-full bg-black/50 border border-white/15 focus:border-[#39FF14] focus:outline-none px-4 py-3" placeholder="admin@ndpl.in" /></label>
          <label className="block"><span className="text-xs uppercase tracking-widest text-white/60">Password</span>
            <input data-testid="admin-password" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} className="mt-2 w-full bg-black/50 border border-white/15 focus:border-[#39FF14] focus:outline-none px-4 py-3" /></label>
          <button data-testid="admin-login-submit" disabled={loading} className="w-full py-3 bg-[#39FF14] text-black font-bold uppercase tracking-widest">{loading ? "..." : "Login"}</button>
        </div>
        <Link to="/" className="block text-center text-xs text-white/40 mt-6 hover:text-white">← Back to site</Link>
      </form>
    </div>
  );
}
